import classNames from "classnames";
import React, { CSSProperties, FunctionComponent } from "react";
import { fontTagToCssClass } from "../../../../agreed/fonts";
import { TemplateLocale } from "../../../../types/customization/common";
import { ContentPage } from "../../../../types/customization/content";
import {
  TemplateCalendar,
  TemplateDateTextDefinition,
} from "../../../../types/customization/template";
import { lengthMmToPx, sizeMmToPx } from "../../../../utils/customization/box";
import {
  findColorDefinition,
  findFontColorDefinition,
  findFontDefinition,
} from "../../../../utils/customization/finders";
import { isDateKey } from "../../../../utils/customization/format/template";
import { findLocalizedContent } from "../../../../utils/customization/localized";
import {
  calcTextProperties,
  DEFAULT_FONT_COLOR,
  textAlignToCss,
  textOrientationToCss,
} from "../../../../utils/customization/text";
import "./style.scss";

interface Props {
  elementDefinition: TemplateDateTextDefinition;
  locale: TemplateLocale;
  onClick?: () => void;
  page: ContentPage;
  ppmm: number;
  template: TemplateCalendar;
}

const DateText: FunctionComponent<Props> = ({
  elementDefinition,
  locale,
  onClick,
  page,
  ppmm,
  template,
}) => {
  const fontDefinition = findFontDefinition(elementDefinition.fontKey, template);

  const { boxSize, fontSizeLength, lineHeightLength } = calcTextProperties(
    elementDefinition,
    fontDefinition
  );

  const style: CSSProperties = {
    ...textAlignToCss(elementDefinition.textAlign),
    ...textOrientationToCss(elementDefinition.textOrientation, sizeMmToPx(boxSize, ppmm)),
  };

  const colorDefinition = findColorDefinition(page.backgroundColorKey, template.colorDefinitions);
  const fontColorDefinition = colorDefinition
    ? findFontColorDefinition(elementDefinition.fontColorKey, colorDefinition)
    : undefined;

  const contentStyle: CSSProperties = {
    color: fontColorDefinition?.value || DEFAULT_FONT_COLOR,
    fontSize: `${lengthMmToPx(fontSizeLength, ppmm).value}px`,
    lineHeight: `${lengthMmToPx(lineHeightLength, ppmm).value}px`,
  };

  let forcedContent = "";
  const dateTextValue = page.dateTexts?.find(
    (dateText) => dateText.dateTextKey === elementDefinition.key
  );

  if (dateTextValue) {
    const textDefinition = template.dateDefinitions.find(
      (definition) => definition.key === elementDefinition.dateDefinitionKey
    );

    if (textDefinition && isDateKey(dateTextValue.contentKey)) {
      const localizedContent = findLocalizedContent(
        textDefinition.values[dateTextValue.contentKey],
        locale
      );
      forcedContent = `${localizedContent.content}${dateTextValue.suffix || ""}`;
    }
  }

  return (
    <div className="DateText" onClick={onClick} style={style}>
      <div
        className={classNames("DateText-content", fontTagToCssClass(fontDefinition.fontTag))}
        style={contentStyle}
      >
        {forcedContent}
      </div>
    </div>
  );
};

export default DateText;
